import React from "react";
import { StyleSheet, View, Text, TouchableOpacity } from "react-native";
import { colors } from "src/assets";

export type ListItemProps = {
  text?: string;
  date?: string;
  isNew?: boolean;
  onPress?: () => void;
};

export const ListItem: React.FC<ListItemProps> = ({
  text,
  date,
  isNew,
  onPress,
}) => {
  return (
    <TouchableOpacity style={styles.container} onPress={onPress}>
      <View style={styles.content}>
        {date ? <Text style={styles.date}>{date}</Text> : null}
        <Text style={styles.text}>{text}</Text>
      </View>
      <View style={styles.rightContainer}>
        {isNew ? <View style={styles.isNew} /> : null}
        <svg width="7.63" height="12.777" viewBox="0 0 7.63 12.777">
          <path
            id="シェイプ_13"
            data-name="シェイプ 13"
            d="M673.474,1210.877a1.133,1.133,0,0,1,.8.333l5.358,5.358a1.136,1.136,0,0,1,0,1.607l-5.147,5.147a1.136,1.136,0,1,1-1.607-1.607l4.344-4.344-4.554-4.554a1.136,1.136,0,0,1,.8-1.94Z"
            transform="translate(-672.338 -1210.877)"
            fill="#a5a5a5"
          />
        </svg>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 16,
    paddingVertical: 12,
    backgroundColor: colors.white,
    borderBottomColor: colors.gray1,
    borderBottomWidth: 1,
  },
  content: {
    flex: 1,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
  },
  text: {
    color: colors.chokuBlack,
    fontSize: 15,
    fontWeight: "600",
  },
  date: {
    color: colors.chokuGray,
    fontSize: 12,
    fontWeight: "600",
    marginBottom: 4,
  },
  isNew: {
    marginRight: 8,
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: colors.chokuRed,
  },
  rightContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
});
